import { deepConvertNumericStringsToNumbers } from './deepConvertNumericStringsToNumbers';
import { NextRouter } from 'next/router';

export const variablesFromURLParams = (router: NextRouter): Record<string, unknown> => {
  const { query } = router;
  const variablesFromURL: Record<string, any> = {};

  const transformValue = (value: string | string[]): any => {
    if (value === 'null') {
      return null;
    }

    // handle array-like string structures or comma-separated values without converting to numbers
    if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
      let items = value
        .substring(1, value.length - 1)
        .split(',')
        .map((item: string) => {
          const trimmedItem = item.trim();
          return trimmedItem === 'null' ? null : decodeURIComponent(trimmedItem);
        });
      return items;
    } else if (typeof value === 'string' && value.includes(',')) {
      // process comma-separated string as an array
      return value.split(',').map((item: string) => {
        const trimmedItem = item.trim();
        return trimmedItem === 'null' ? null : decodeURIComponent(trimmedItem);
      });
    }

    // for single string values, decode URI component
    if (typeof value === 'string') {
      return decodeURIComponent(value);
    }

    // if it's already an array (from query parameters directly provided as array), just return it as is
    if (Array.isArray(value)) {
      return value.map((item: string) => (item === 'null' ? null : decodeURIComponent(item)));
    }
  };

  for (const key in query) {
    if (Object.prototype.hasOwnProperty.call(query, key) && !['appName', 'dashboardName'].includes(key)) {
      const keys = key.split('.');
      let value = query[key];

      // apply transformation to the value
      const transformedValue = value !== undefined ? transformValue(value) : value;

      // construct the nested object structure
      let currentLevel = variablesFromURL;
      for (let i = 0; i < keys.length - 1; i++) {
        currentLevel[keys[i]] = currentLevel[keys[i]] || {};
        currentLevel = currentLevel[keys[i]];
      }

      currentLevel[keys[keys.length - 1]] = transformedValue;
    }
  }

  // convert all values in variablesFromURL to numbers if they are any numeric strings
  deepConvertNumericStringsToNumbers(variablesFromURL);
  return variablesFromURL;
};
